import { defineMessages } from 'react-intl';

export default defineMessages({
  acknowledge: {
    id: 'app.components.EmergencyModeList.acknowledge',
    defaultMessage: 'Acknowledge',
  },
  acknowledgeConcise: {
    id: 'app.components.EmergencyModeList.acknowledgeConcise',
    defaultMessage: 'Acknowledge',
  },
  reportAsSafe: {
    id: 'app.components.EmergencyModeList.reportAsSafe',
    defaultMessage: 'Report as safe',
  },
  reportAsSafeConcise: {
    id: 'app.components.EmergencyModeList.reportAsSafeConcise',
    defaultMessage: 'Safe',
  },
  Unknown: {
    id: 'app.components.EmergencyModeList.unknown',
    defaultMessage: 'Unknown',
  },
  Acknowledged: {
    id: 'app.components.EmergencyModeList.acknowledged',
    defaultMessage: 'Acknowledged',
  },
  Safe: {
    id: 'app.components.EmergencyModeList.safe',
    defaultMessage: 'Safe',
  },
  status: {
    id: 'app.components.EmergencyModeList.status',
    defaultMessage: 'Status',
  },
  statusMessage: {
    id: 'app.components.EmergencyModeList.statusMessage',
    defaultMessage: 'Note',
  },
  fullName: {
    id: 'app.components.EmergencyModeList.fullName',
    defaultMessage: 'Full name',
  },
  routeName: {
    id: 'app.components.EmergencyModeList.routeName',
    defaultMessage: 'Route Name',
  },
  phone: {
    id: 'app.components.EmergencyModeList.phone',
    defaultMessage: 'Phone',
  },
  noPhoneNumberGiven: {
    id: 'app.components.EmergencyModeList.noPhoneNumberGiven',
    defaultMessage: 'No phone number given',
  },
  shift: {
    id: 'app.components.EmergencyModeList.shift',
    defaultMessage: 'Shift',
  },
  email: {
    id: 'app.components.EmergencyModeList.email',
    defaultMessage: 'Email',
  },
  action: {
    id: 'app.components.EmergencyModeList.action',
    defaultMessage: 'Action',
  },
  acknowledgeDialogTitle: {
    id: 'app.components.EmergencyModeList.acknowledgeDialogTitle',
    defaultMessage: 'Set publisher status',
  },
  acknowledgeDialogDescription: {
    id: 'app.components.EmergencyModeList.acknowledgeDialogDescription',
    defaultMessage: "Optional additional note about the publisher's status.",
  },
  acknowledgeDialogStatusMessage: {
    id: 'app.components.EmergencyModeList.acknowledgeDialogStatusMessage',
    defaultMessage: 'Status message',
  },
  acknowledgeDialogConfirm: {
    id: 'app.components.EmergencyModeList.acknowledgeDialogConfirm',
    defaultMessage: 'Publisher has acknowledged',
  },
  acknowledgeDialogCancel: {
    id: 'app.components.EmergencyModeList.acknowledgeDialogCancel',
    defaultMessage: 'Cancel',
  },
  reportAsSafeDialogTitle: {
    id: 'app.components.EmergencyModeList.reportAsSafeDialogTitle',
    defaultMessage: 'Set publisher status',
  },
  reportAsSafeDialogDescription: {
    id: 'app.components.EmergencyModeList.reportAsSafeDialogDescription',
    defaultMessage: "Optional additional note about the publisher's status.",
  },
  reportAsSafeDialogStatusMessage: {
    id: 'app.components.EmergencyModeList.reportAsSafeDialogStatusMessage',
    defaultMessage: 'Status message',
  },
  reportAsSafeDialogConfirm: {
    id: 'app.components.EmergencyModeList.reportAsSafeDialogConfirm',
    defaultMessage: 'Publisher is safe',
  },
  reportAsSafeDialogCancel: {
    id: 'app.components.EmergencyModeList.reportAsSafeDialogCancel',
    defaultMessage: 'Cancel',
  },
  statusEditDialogTitle: {
    id: 'app.components.StatusEditButton.dialogTitle',
    defaultMessage: 'Update Status',
  },
  statusEditDialogDescription: {
    id: 'app.components.StatusEditButton.dialogDescription',
    defaultMessage: 'Update the status for this participant',
  },
  statusEditStatusMessageLabel: {
    id: 'app.components.StatusEditButton.statusMessageLabel',
    defaultMessage: 'Status Message',
  },
  statusEditStatusMessagePlaceholder: {
    id: 'app.components.StatusEditButton.statusMessagePlaceholder',
    defaultMessage: 'Enter status message',
  },
  statusEditCancel: {
    id: 'app.components.StatusEditButton.cancel',
    defaultMessage: 'Cancel',
  },
  statusEditSave: {
    id: 'app.components.StatusEditButton.save',
    defaultMessage: 'Save',
  },
  statusEditSaving: {
    id: 'app.components.StatusEditButton.saving',
    defaultMessage: 'Saving...',
  },
});
